<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control">
          <label class="label">Name</label>
          <input :class="{'input': true, 'is-danger': errors.has('name'), 'is-disabled': inProgress}" type="text" name="name" id="name" placeholder="Name" v-model="rule.name" v-validate="'required'">
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </p>
        <p class="control">
          <label class="label">Type</label>
          <select :class="{'select': true, 'is-fullwidth': true }" v-model="rule.type" name="type" id="type">
            <option value="1">Invoice</option>
            <option value="2">Payment Order</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Generation Period</label>
          <select :class="{'select': true, 'is-fullwidth': true }" v-model="rule.date_type" name="date_type" id="date_type">
            <option value="1">Daily</option>
            <option value="2">Biweekly</option>
            <option value="3">Monthly</option>
            <option value="4">Custom</option>
            <option value="5">Weekly</option>
          </select>
        </p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded" v-if="parseInt(rule.date_type) === 4 || parseInt(rule.date_type) === 3">
              <label class="label">Start</label>
              <input :class="{'input': true, 'is-danger': errors.has('date_ini'), 'is-disabled': inProgress}" type="text" name="date_ini" id="date_ini" placeholder="Start" v-model="rule.date_ini" v-validate="'numeric|required'">
              <span v-show="errors.has('date_ini')" class="help is-danger">{{ errors.first('date_ini') }}</span>
            </p>
            <p class="control is-expanded" v-if="parseInt(rule.date_type) === 4 || parseInt(rule.date_type) === 3">
              <label class="label">End</label>
              <input :class="{'input': true, 'is-danger': errors.has('date_end'), 'is-disabled': inProgress}" type="text" name="date_end" id="date_end" placeholder="End" v-model="rule.date_end" v-validate="'numeric|required'">
              <span v-show="errors.has('date_end')" class="help is-danger">{{ errors.first('date_end') }}</span>
            </p>
            <p class="control is-expanded" v-if="parseInt(rule.date_type) === 4">
              <label class="label">Days</label>
              <input :class="{'input': true, 'is-danger': errors.has('days'), 'is-disabled': inProgress}" type="text" name="days" id="days" placeholder="Days" v-model="rule.days" v-validate="'numeric|required'">
              <span v-show="errors.has('days')" class="help is-danger">{{ errors.first('days') }}</span>
            </p>
            <p class="control is-expanded" v-if="parseInt(rule.date_type) === 4 || parseInt(rule.date_type) === 3">
              <label class="label">Deadline</label>
              <input :class="{'input': true, 'is-danger': errors.has('deadline'), 'is-disabled': inProgress}" type="text" name="deadline" id="deadline" placeholder="Deadline" v-model="rule.deadline" v-validate="'numeric|required'">
              <span v-show="errors.has('deadline')" class="help is-danger">{{ errors.first('deadline') }}</span>
            </p>
            <p class="control is-expanded" v-if="parseInt(rule.date_type) === 1 || parseInt(rule.date_type) === 5">
              <label class="label">Deadline Days</label>
              <input :class="{'input': true, 'is-danger': errors.has('deadline_days'), 'is-disabled': inProgress}" type="text" name="deadline_days" id="deadline_days" placeholder="Deadline Days" v-model="rule.deadline_days" v-validate="'numeric|required'">
              <span v-show="errors.has('deadline_days')" class="help is-danger">{{ errors.first('deadline') }}</span>
            </p>
          </div>
        </div>
        <p class="control">
          <label class="label">By</label>
          <select :class="{'select': true, 'is-fullwidth': true, 'is-danger': errors.has('type') }" v-model="rule.checkin_reservation" name="checkin_reservation" id="checkin_reservation">
            <option value="1">Check-in</option>
            <option value="2">Reservation</option>
          </select>
          <span v-show="errors.has('type')" class="help is-danger">{{ errors.first('type') }}</span>
        </p>
        <p class="control is-expanded" v-if="parseInt(rule.checkin_reservation) === 1">
          <label class="label">Days Before Check-in</label>
          <input :class="{'input': true, 'is-danger': errors.has('days_checkin'), 'is-disabled': inProgress}" type="text" name="days_checkin" id="days_checkin" placeholder="Days" v-model="rule.days_checkin" v-validate="'numeric|required'">
          <span v-show="errors.has('days_checkin')" class="help is-danger">{{ errors.first('days_checkin') }}</span>
        </p>
        <p class="control is-expanded">
          <label class="label">Date Restriction</label>
          <datepicker ref="date_restriction" placeholder="Date"></datepicker>
        </p>
        <p class="control is-expanded">
          <label class="checkbox">
            <input type="checkbox" v-model="rule.one_book">
            One Book
          </label>
        </p>
        <p class="control">
          <label class="checkbox">
            <input type="checkbox" v-model="rule.active">
            Active
          </label>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress }" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any(), 'is-loading': inProgress}" @click="save">{{ rule.id ? 'Save' : 'New'}}</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vue-bulma-datepicker'
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      id: {
        type: Number
      }
    },
    data () {
      return {
        rule: {
          id: null,
          name: '',
          type: 1,
          date_type: 1,
          date_ini: '',
          date_end: '',
          days: '',
          deadline: '',
          checkin_reservation: 1,
          active: false,
          date_restriction: '',
          days_checkin: '',
          deadline_days: '',
          one_book: 0
        },
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.id) {
          this.rule.id = this.id
          this.loadData()
        } else {
          document.body.appendChild(this.$el)
        }
      })
    },
    methods: {
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      save () {
        this.rule.date_restriction = this.$refs.date_restriction.datepicker.input.value
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0) {
            this.inProgress = true
            this.error = ''
            let url = this.context.$store.state.config.apiURL + '/invoice_payment_rules'
            if (this.rule.id) {
              url = this.context.$store.state.config.apiURL + '/invoice_payment_rules/' + this.rule.id
            }
            this.context.$http.post(url, this.rule).then((response) => {
              this.inProgress = false
              this.close(false, {ok: true, message: 'The Invoice/P.O Order ' + response.body.name + ' was successfully saved'})
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          }
        })
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/invoice_payment_rules/' + this.rule.id).then((response) => {
          this.rule = response.body
          document.body.appendChild(this.$el)
        }, (response) => {
        })
      }
    },
    components: {
      Datepicker
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// InvoicePaymentRule.vue?7def8d56